import { QueryClient } from '@tanstack/react-query';

/**
 * Most tournament data reaches the UI through Firestore `onSnapshot`
 * subscriptions, which push updates into the query cache themselves. Automatic
 * refetching would therefore only duplicate work, so it is switched off and the
 * cache is treated as live-owned by the subscriptions.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
